import ContactEdit from "./pages/ContactEdit";
import ContactList from "./pages/ContactList";
import CreateContact from "./pages/CreateContact";
import ViewContact from "./pages/ViewContact";

const contactRoutes = [
  {
    path: "/masters/contact",
    element: <ContactList />,
  },
  {
    path: "/masters/contact/create",
    element: <CreateContact />,
  },
  {
    path: "/masters/contact/view/:id",
    element: <ViewContact />,
  },
  {
    path: "/masters/contact/edit/:id",
    element: <ContactEdit />,
  },
];

export default contactRoutes;